import dayjs from 'dayjs'
import { history } from '../../../store'

/**
@description Gets the table configuration object for StockDiscrepanciesLogTable.
*/

export const getTableColumns = () => {
  const columns = [
    {
      key: 'timeLogged',
      sortable: true,
      sortKey: 'timeLoggedSortValue',
      title: 'Time Logged',
      columnType: 'dateTime'
    },
    {
      key: 'resident',
      title: 'Resident',
      cellType: 'resident'
    },
    // {
    //     key: 'log',
    //     title: 'Logs',
    //     cellType: 'log'
    // },
    {
      key: 'emarResidentMedication',
      title: 'Medication',
      cellType: 'emarResidentMedication'
    },
    {
      centred: true,
      key: 'actualStock',
      title: `Stock Count`,
      cellType: 'actualStock'
    },
    {
      centred: true,
      key: 'expectedStock',
      title: `Expected Stock`,
      cellType: 'center'
    }
  ]

  return columns
}

/**
@description Gets the table data for StockDiscrepanciesLogTable. Returns an array of row objects.
@param {array} logs. The medication logs.
*/

export const getTableRows = (props) => {
  const { logs } = props

  return logs.map((log, index) => {
    const {
      actualStock,
      expectedStock,
      id,
      resident,
      timeLogged,
      emarResidentMedication
    } = log

    if (!log) return null

    const actualStockOnSelect = () => history.push(`/logs/${id}`)
    const residentOnSelect = () =>
      history.push(`/residents/${resident.id}/emar/stock`)

    return {
      key: id,
      timeLogged: {
        style: styles.timeLogged,
        value: dayjs(timeLogged).format('DD-MM-YYYY HH:mm')
      },
      timeLoggedSortValue: dayjs(timeLogged).format('DD-MM-YYYY HH:mm'),
      resident: { resident, onSelect: residentOnSelect },
      emarResidentMedication,
      actualStock: {
        actualStock,
        expectedStock,
        onSelect: actualStockOnSelect,
        showExpectedStock: true
      },
      expectedStock
    }
  })
}

const styles = {
  timeLogged: {
    minWidth: 120
  }
}
